// Game status constants
export const GAME_STATUS = {
  IDLE: 'IDLE',                    // 세로선만 표시
  SELECTING: 'SELECTING',          // 시작점 선택 중
  SHUFFLING: 'SHUFFLING',          // 상품 섞는 중
  GENERATING: 'GENERATING',        // 가로선 생성 중
  ANIMATING: 'ANIMATING',          // 사다리 타기 애니메이션
  RESULT: 'RESULT',                // 결과 표시
};

// Action types
export const ACTIONS = {
  INITIALIZE_GAME: 'INITIALIZE_GAME',
  SELECT_START: 'SELECT_START',
  START_GAME: 'START_GAME',                // 상품 shuffle 시작
  COMPLETE_SHUFFLE: 'COMPLETE_SHUFFLE',    // 상품 shuffle 완료 → 가로선 생성
  UPDATE_ANIMATION: 'UPDATE_ANIMATION',
  COMPLETE_ANIMATION: 'COMPLETE_ANIMATION',
  RESTART_GAME: 'RESTART_GAME',
};

// Canvas configuration (defaults)
export const CANVAS_CONFIG = {
  width: 800,
  height: 750, // 기본 높이
  padding: 60,
  lineWidth: 3,
  ladderBarWidth: 12,
  ladderRungHeight: 12,
  ballRadius: 10,
  playerImgSize: 88,
  playerOffsetX: 25,
  playerOffsetY: -20,
  playerSelectedLift: 40,
  rewardTextShadowColor: 'black',
  rewardTextShadowOffsetY: 1,
  rewardTextShadowBlur: 1,
  pointerImgSize: 74,
  animationDuration: 6000,
  minHorizontalSpacing: 40,              // 같은 칸 내 가로선 최소 간격 (예: 1-2 칸)
  neighborHorizontalSpacing: 30,        // 인접 칸 가로선 최소 간격 (예: 1-2 vs 2-3)
};

// Get canvas config with custom height from game config
export function getCanvasConfig(gameConfig) {
  return {
    ...CANVAS_CONFIG,
    height: gameConfig?.canvasHeight || CANVAS_CONFIG.height,
  };
}

// Ladder canvas layout (player labels top, reward cards bottom)
export const LADDER_LAYOUT = {
  ladderHeightRatio: 1,
  playerAreaHeight: 56,
  rewardCardHeight: 80,
  rewardCardBottomGap: 10,
  ladderBottomGap: 15,
  ladderTopMargin: 40,
  ladderBottomMargin: 40,
};

export function getLadderBounds(gameConfig) {
  const canvasConfig = getCanvasConfig(gameConfig);
  const { padding, height } = canvasConfig;
  const {
    ladderHeightRatio,
    playerAreaHeight,
    rewardCardHeight,
    rewardCardBottomGap,
    ladderBottomGap,
    ladderTopMargin,
    ladderBottomMargin,
  } = LADDER_LAYOUT;

  const barHalf = canvasConfig.ladderBarWidth / 2;
  const rungHalf = canvasConfig.ladderRungHeight / 2;

  const ladderTop = padding + playerAreaHeight;

  // Reward card position at the bottom
  const rewardCardTop = height - padding - rewardCardBottomGap - rewardCardHeight;

  // Available space for ladder zone (from top to reward card minus gap)
  const availableSpace = rewardCardTop - ladderTop - ladderBottomGap;
  const ladderZoneHeight = availableSpace * ladderHeightRatio;
  const ladderZoneBottom = ladderTop + ladderZoneHeight;

  // 3D 세로 기둥: 하단 둥근 모서리가 gap을 침범하지 않도록 inset
  const ladderBottom = ladderZoneBottom - barHalf;

  // 3D 가로 rung 중심 허용 범위 (rung 두께 + shadow 여유 포함)
  const rungAreaTop = ladderTop + ladderTopMargin + rungHalf;
  const rungAreaBottom = ladderZoneBottom - ladderBottomMargin - rungHalf;

  return {
    ladderTop,
    ladderBottom,
    rungAreaTop,
    rungAreaBottom,
    pathTop: ladderTop,
    pathBottom: rungAreaBottom,
    rewardCardTop,
    rewardCardCenterY: rewardCardTop + rewardCardHeight / 2,
    rewardCardHeight,
    playerAreaHeight,
  };
}

// UI text for bilingual support
export const UI_TEXT = {
  ko: {
    start: '시작',
    restart: '다시 하기',
    result: '결과',
    loading: '게임을 준비 중입니다...',
    loadingStatus: '확인 중...',
    close: '닫기',
    loginToPlay: '로그인하고 시작하기',
    alreadyPlayed: '오늘 참여 완료',
    starting: '시작 중...',
    earned: '적립!'
  },
  en: {
    start: 'Start',
    restart: 'Play Again',
    result: 'Result',
    loading: 'Preparing game...',
    loadingStatus: 'Checking...',
    close: 'Close',
    loginToPlay: 'Login to Play',
    alreadyPlayed: 'Already played today',
    starting: 'Starting...',
    earned: 'earned!'
  },
};

// Ladder game default configuration
export const LADDER_GAME_CONFIG = {
  playerCount: 6,
  horizontalLineCount: 30,
  canvasHeight: 750,
  players: [
    { id: '1', name: '1번', nameEn: 'Player 1' },
    { id: '2', name: '2번', nameEn: 'Player 2' },
    { id: '3', name: '3번', nameEn: 'Player 3' },
    { id: '4', name: '4번', nameEn: 'Player 4' },
    { id: '5', name: '5번', nameEn: 'Player 5' },
    { id: '6', name: '6번', nameEn: 'Player 6' },
  ],
};